var _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchased(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 71,
    viewBox: "0 0 238 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.505 49.8387C233.505 48.5967 234.086 47.5098 234.924 46.5265C235.246 30.3795 234.859 3.72657 234.859 3.72657C231.185 1.29417 23.5297 -3.20837 5.09155 3.72657C5.09155 3.72657 2.64173 57.55 5.67177 59.4131C8.70182 61.2762 232.667 62.0525 234.15 58.3263C234.408 57.7052 234.601 55.7904 234.73 53.0475C233.957 52.1159 233.505 51.0291 233.505 49.787V49.8387Z",
    fill: "url(#paint0_linear_5770_110529)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.728 53.0997C234.599 55.8426 234.406 57.7575 234.148 58.3785C232.665 62.1047 8.69981 61.3284 5.66976 59.4653C2.63972 57.6022 5.08954 3.77881 5.08954 3.77881L0.963527 13.3532C0.963527 13.3532 -1.55077 67.1765 1.54375 69.0397C4.70273 70.9028 234.922 71.6791 236.469 67.9529C236.92 66.866 237.178 61.8459 237.307 55.2733C236.276 54.6522 235.373 53.9277 234.728 53.0997Z",
    fill: "#732200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234.924 46.5788C235.569 45.8542 236.471 45.1814 237.374 44.6639C237.374 29.8107 237.18 13.3532 237.18 13.3532C236.858 13.1461 234.859 3.77881 234.859 3.77881C234.859 3.77881 235.246 30.4318 234.924 46.5788Z",
    fill: "#732200"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.59
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44269 59.6201C20.2391 61.2762 210.165 61.8973 232.084 58.8956C234.212 61.1727 235.824 63.7086 236.726 66.6586C236.662 67.2278 236.533 67.6936 236.468 67.9006C234.921 71.6269 4.70202 70.8506 1.54304 68.9874C1.47857 68.9357 1.34963 68.8322 1.28516 68.6769C2.38113 65.4682 4.1218 62.4148 6.44269 59.5683V59.6201Z",
    fill: "#732200"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M18.9509 36.1237C21.5296 36.7448 23.2058 38.6079 25.978 39.1254C34.1011 40.7298 55.8917 30.2239 61.8228 36.7448C57.8257 37.4176 50.3473 38.4526 47.5107 40.9368C45.1253 43.0069 45.7055 43.4727 48.6711 43.835C50.6697 44.042 53.3773 42.9552 55.3114 42.5411C60.0177 41.5578 64.7239 40.7815 69.5591 40.2123C77.6822 39.2807 85.8053 39.1772 93.9284 39.4877C104.888 39.9535 114.945 42.8517 125.518 44.8701C129.322 45.5946 139.959 48.5963 143.57 46.5779C147.051 44.6631 142.603 45.0771 142.409 43.0587C141.958 38.8667 160.203 36.9518 163.297 36.5378C176.062 34.9334 189.085 34.8817 201.914 35.865C206.943 36.2272 210.295 37.8834 215.001 38.8667C221.061 40.1087 227.637 38.5044 233.826 39.0737C234.02 39.0737 234.471 39.1772 234.987 39.3325C234.987 37.0036 234.987 34.5712 234.987 32.1388C231.634 32.087 228.217 31.9317 224.736 31.4659C220.997 31.0002 210.166 28.2573 206.878 29.5511C214.872 26.3942 225.252 24.0135 234.922 23.4442C234.922 22.6162 234.922 21.8399 234.922 21.0118C234.213 21.1153 233.439 21.2188 232.795 21.2705C223.382 22.4091 214.228 24.3758 205.202 26.7047C194.565 29.4476 183.411 28.6713 172.452 29.1371C163.942 29.4993 156.334 31.2589 148.534 33.7431C140.862 36.1237 133.641 39.9535 125.131 39.9017C117.395 39.85 110.11 37.3141 102.374 36.7965C98.6991 36.5378 75.7481 39.4359 73.8785 36.4343C72.2668 33.8466 80.7122 32.708 81.5503 30.7414C72.2668 27.3257 59.373 29.1888 49.7026 30.2239C45.3187 30.6897 31.7158 33.8466 30.0396 28.7748C36.5509 29.9651 43.707 27.1704 50.025 25.9801C61.0492 23.9617 71.4932 24.5828 82.5174 26.3941C93.1548 28.1538 103.792 30.5344 114.687 30.2239C126.421 29.9134 138.154 28.2055 149.759 27.0669C161.041 25.9284 172.387 24.8933 183.669 23.5477C193.34 22.4091 201.463 17.6996 210.94 15.7847C218.805 14.1804 226.799 13.1453 234.858 12.5243C234.858 9.16032 234.793 6.52089 234.793 5.0718C226.283 4.08848 217.709 3.41568 209.135 3.15691C197.53 2.84639 185.99 5.69284 174.579 3.26044C176.191 2.38064 178.061 1.70782 180.059 1.13854C170.582 0.879772 160.332 0.672784 149.694 0.517525C145.052 1.55259 140.475 2.58764 135.833 3.57095C118.556 7.40069 104.63 4.19201 88.2551 0.517525C87.2881 0.310512 86.321 0.103506 85.354 0C80.7122 0 76.1994 -2.84278e-05 71.751 0.0517248C61.7583 1.2938 51.8946 4.39899 41.7729 4.65776C29.137 4.96828 16.2432 3.00167 4.89663 8.22875C4.89663 8.59102 4.89663 8.9533 4.89663 9.36733C18.1128 3.77797 33.5854 7.45244 47.7685 6.15861C55.3759 5.48582 62.6609 3.36392 70.1393 2.22535C75.1679 1.44905 80.261 1.08678 85.2251 2.22535C89.0932 3.10516 92.639 4.81303 96.3137 6.00336C111.722 11.0234 125.841 8.07347 141.249 5.74457C150.79 4.29548 167.165 0.879769 175.288 7.03841C166.456 8.33224 158.204 9.78136 149.694 12.162C143.118 14.0251 136.542 16.1987 129.644 16.9233C121.328 17.8031 112.56 17.6479 104.437 16.0435C100.246 15.2154 96.3137 13.3006 92.1877 12.6278C79.5518 10.4024 66.1422 17.2856 53.4418 17.1821C48.2198 17.1821 38.8718 14.5944 43.1912 9.10854C37.5824 6.98666 29.6527 8.74628 23.915 9.52258C17.3391 10.4024 10.9567 11.748 4.70322 13.5076C4.70322 14.1804 4.70322 14.8532 4.70322 15.5777C12.5684 14.2321 20.5626 13.4041 28.6212 13.3006C30.8776 13.3006 33.1341 13.3523 35.3905 13.3006C39.2586 13.3006 37.4535 13.0935 39.1942 14.8014C41.1282 16.768 42.4821 17.3891 45.6411 17.9583C55.6982 19.718 66.7869 17.4926 76.9086 16.9751C88.7709 16.4058 99.4727 18.6829 111.206 19.4592C133.512 20.96 155.496 13.9733 177.287 11.2822C189.214 9.83308 201.656 9.0568 214.099 9.16031C213.39 9.26381 212.68 9.36731 211.971 9.47081C207.458 10.1954 203.01 11.2304 198.755 12.6795C193.791 14.3356 189.729 16.8715 184.443 17.6996C172.774 19.5627 160.718 20.5978 148.92 22.0469C136.865 23.5477 124.616 25.5661 112.431 25.7731C100.762 25.9801 90.0602 23.6512 78.7137 21.9951C67.9474 20.4425 58.0191 20.7013 47.3817 22.7197C41.7729 23.8065 36.1641 25.1521 30.4264 25.6178C24.4308 26.1354 18.4351 25.2556 12.504 24.9968C9.79627 24.8933 7.15304 24.9451 4.50981 25.1003C4.44534 29.0336 4.31641 33.1738 4.31641 37.1588C5.9926 36.9518 7.60432 36.693 9.28051 36.5378C12.1816 36.1755 16.1787 35.2439 19.1443 35.9167L18.9509 36.1237Z",
    fill: "url(#paint1_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M233.504 49.8378C233.504 48.5957 234.084 47.5089 234.922 46.5256C234.922 46.215 234.922 45.9045 234.922 45.594C223.253 48.5957 210.553 50.5105 198.949 51.5974C188.311 52.5807 178.383 52.8395 168.712 48.5439C173.032 42.4888 199.916 39.1766 206.298 43.5239C204.686 45.2317 199.658 46.8878 198.175 47.8194C203.332 47.3536 213.905 46.5256 217.387 43.1616C210.295 38.245 194.113 39.7459 185.668 40.7292C176.384 41.7643 159.687 43.8344 153.24 49.579C156.012 52.9429 160.396 54.5473 164.393 56.6174C151.112 51.9079 138.992 49.2167 124.68 48.4404C109.788 47.6641 94.3152 46.7326 79.4229 48.0264C71.8155 48.6992 64.2082 49.579 56.6008 50.0448C52.4103 50.3036 47.8975 50.9763 43.7715 50.0448C40.6125 49.372 38.2916 47.6641 35.3905 46.5773C26.3648 43.2134 14.2447 44.7659 4.1875 47.1466C4.1875 47.5606 4.1875 48.0264 4.1875 48.4404C9.34502 47.7159 14.5025 47.0948 19.7245 46.8361C24.044 46.6291 28.4923 46.5773 32.6828 47.7159C35.6484 48.4922 37.8403 50.2 40.6125 51.2351C45.3187 52.9947 50.8631 52.3219 55.8917 52.0114C63.628 51.5974 71.2998 50.9246 78.9716 50.6141C93.4127 50.0965 107.596 52.8394 121.843 54.392C117.975 54.6508 114.107 54.7543 110.11 54.4956C102.309 53.978 94.5731 52.8395 86.7079 53.0465C78.9071 53.2535 71.2353 54.392 63.499 55.1683C53.3774 56.1517 44.2873 55.8929 34.4235 53.978C27.8476 52.6842 21.0784 51.1316 14.2447 52.0632C10.7633 52.5289 7.60436 53.6675 4.63878 55.0649C4.63878 55.4271 4.70325 55.7894 4.76772 56.1517C10.1187 54.0298 15.663 52.5807 21.981 53.15C29.8462 53.8228 37.2601 56.4104 45.1898 57.0832C60.9847 58.4806 76.4573 53.9263 92.3167 55.1166C99.7306 55.6859 106.887 57.2385 114.172 58.2218C121.779 59.2569 129.129 59.2051 136.8 58.8946C145.117 58.5841 153.369 59.9814 161.556 60.8612C169.035 60.8094 176.32 60.7059 183.089 60.6542C183.605 60.5507 184.056 60.4472 184.572 60.3437C185.861 60.0332 186.57 59.0498 186.57 58.1183C196.047 57.2902 205.202 55.7894 214.679 54.4956C221.126 53.6158 227.573 52.8394 234.02 51.9596C233.697 51.3386 233.504 50.6141 233.568 49.8895L233.504 49.8378Z",
    fill: "url(#paint2_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M53.4463 17.9066C66.1467 17.9584 79.4918 11.1269 92.1922 13.3523C96.3182 14.0769 100.251 15.9917 104.441 16.768C112.629 18.3724 121.332 18.4759 129.649 17.6478C136.611 16.9233 143.123 14.7497 149.699 12.8866C158.209 10.5059 166.461 9.05682 175.293 7.76299C175.035 7.55598 174.648 7.34895 174.39 7.14194C165.945 8.43577 157.886 9.8331 149.699 12.1102C143.123 13.9734 136.547 16.147 129.649 16.8715C121.332 17.7513 112.564 17.5961 104.441 15.9917C100.251 15.1637 96.3182 13.2488 92.1922 12.576C79.5563 10.3506 66.1467 17.2338 53.4463 17.1303C49.2558 17.1303 42.551 15.4742 42.0998 12.0585C41.584 15.9917 48.998 17.8549 53.4463 17.8549V17.9066Z",
    fill: "url(#paint3_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M49.833 31.0002C59.3744 29.9652 71.9459 28.2055 81.165 31.3625C81.4228 31.1555 81.5518 31.0002 81.6807 30.7932C72.3972 27.3775 59.5034 29.2406 49.833 30.2757C45.707 30.7415 33.3934 33.5361 30.5568 29.6546C30.4278 29.6546 30.2989 29.6546 30.1055 29.6029C31.7817 34.6229 45.3847 31.5178 49.7685 31.052L49.833 31.0002Z",
    fill: "url(#paint4_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M144.734 45.8016C145.701 44.7666 142.929 44.7665 142.478 43.2657C142.478 43.4209 142.413 43.628 142.478 43.7833C142.607 44.9736 144.154 45.2841 144.734 45.7499V45.8016Z",
    fill: "url(#paint5_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M46.2896 43.1103C46.483 42.748 46.8698 42.2822 47.579 41.6612C50.4156 39.177 57.8295 38.0902 61.8911 37.4692C61.6977 37.2622 61.4398 37.0551 61.1819 36.8481C57.0559 37.5209 50.2867 38.556 47.6434 40.9366C46.354 42.0752 45.9672 42.748 46.354 43.162L46.2896 43.1103Z",
    fill: "url(#paint6_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M200.112 47.6132C202.239 46.6816 205.14 45.4913 206.365 44.2492C206.236 44.1457 206.043 44.0422 205.85 43.9387C203.851 45.4913 199.596 46.9404 198.242 47.7685C198.822 47.7167 199.467 47.6649 200.112 47.6132Z",
    fill: "url(#paint7_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M34.3609 54.7034C44.2246 56.67 53.3148 56.9287 63.4364 55.8937C71.1727 55.1174 78.8445 53.9788 86.6453 53.7718C94.5105 53.5648 102.247 54.7034 110.048 55.2209C114.045 55.4797 117.913 55.3761 121.781 55.1174C120.234 54.9621 118.686 54.7551 117.139 54.5998C114.818 54.6516 112.433 54.5999 109.983 54.4963C102.182 53.9788 94.446 52.8403 86.5808 53.0473C78.7801 53.2543 71.1082 54.3928 63.372 55.1691C53.2503 56.1524 44.1602 55.8937 34.2964 53.9788C27.7206 52.685 20.9513 51.1324 14.1176 52.0639C10.6363 52.5297 7.47729 53.6683 4.51172 55.0656C4.51172 55.3244 4.51172 55.5314 4.57619 55.7902C7.54177 54.3928 10.6363 53.306 14.1176 52.8402C20.9513 51.8569 27.7206 53.4095 34.2964 54.7551L34.3609 54.7034Z",
    fill: "url(#paint8_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M35.4569 47.3544C38.358 48.4412 40.7434 50.1491 43.8379 50.8219C47.8995 51.7017 52.4768 51.0289 56.6673 50.8219C64.3391 50.3561 71.8819 49.4762 79.4893 48.8034C94.3816 47.5096 109.854 48.3894 124.747 49.2175C139.059 49.9938 151.179 52.685 164.46 57.3945C162.912 56.5665 161.301 55.8419 159.753 55.0656C148.278 51.3394 137.318 49.1657 124.747 48.4929C109.854 47.7166 94.3816 46.7851 79.4893 48.0789C71.8819 48.7517 64.2746 49.6315 56.6673 50.0973C52.4768 50.356 47.9639 51.0288 43.8379 50.0973C40.6789 49.4245 38.358 47.7166 35.4569 46.6298C26.4313 43.2659 14.3111 44.8185 4.25391 47.1991C4.25391 47.4579 4.25391 47.7166 4.25391 47.9237C14.3111 45.543 26.4313 43.9386 35.4569 47.3544Z",
    fill: "url(#paint9_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M185.737 40.6785C176.453 41.7135 159.755 43.7837 153.309 49.5283C153.438 49.6836 153.566 49.787 153.695 49.9423C160.4 44.4565 176.646 42.4381 185.737 41.403C193.989 40.4715 209.59 39.0224 216.94 43.5249C217.133 43.3696 217.326 43.2661 217.455 43.1109C210.364 38.1943 194.182 39.6952 185.737 40.6785Z",
    fill: "url(#paint10_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M224.87 31.4659C221.904 31.1037 214.49 29.2923 209.913 29.1888C208.881 29.5511 207.914 29.9134 207.012 30.2756C210.3 28.9818 221.13 31.7247 224.87 32.1905C228.351 32.6562 231.703 32.8115 235.056 32.8633C235.056 32.6045 235.056 32.3458 235.056 32.1387C231.703 32.087 228.287 31.9317 224.805 31.4659H224.87Z",
    fill: "url(#paint11_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M4.70312 14.2319C10.9566 12.4723 17.3391 11.1785 23.9149 10.2469C29.5237 9.47063 37.1955 7.76277 42.8043 9.67764C42.9333 9.47062 43.0622 9.26364 43.2556 9.05662C37.6468 6.93474 29.7171 8.69432 23.9794 9.47062C17.4035 10.3504 11.0211 11.696 4.7676 13.4556C4.7676 14.1284 4.7676 14.8012 4.7676 15.5258C4.7676 15.06 4.7676 14.5942 4.7676 14.1802L4.70312 14.2319Z",
    fill: "url(#paint12_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M169.229 48.7516C169.229 48.7516 168.906 49.1138 168.777 49.3208C178.448 53.6164 188.376 53.3576 199.013 52.3743C210.618 51.3392 223.318 49.3726 234.987 46.4226C234.987 46.1639 234.987 45.9569 234.987 45.6981C223.318 48.6998 210.618 50.6147 199.013 51.7015C188.569 52.633 178.77 52.9435 169.293 48.855L169.229 48.7516Z",
    fill: "url(#paint13_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M4.31841 26.0322C6.89717 25.8252 9.5404 25.7735 12.3126 25.9287C18.2437 26.1875 24.3038 27.0673 30.235 26.5498C35.9727 26.084 41.5815 24.6867 47.1903 23.6516C57.8277 21.6332 67.756 21.3744 78.5223 22.927C89.8688 24.5831 100.571 26.912 112.24 26.705C124.424 26.498 136.673 24.4796 148.729 22.927C160.527 21.4262 172.583 20.4429 184.252 18.5798C189.538 17.7 193.664 15.2158 198.564 13.5597C202.819 12.1624 207.267 11.1273 211.78 10.351C212.489 10.2475 213.198 10.144 213.907 10.0405C212.425 10.0405 210.942 10.0405 209.523 10.0405C205.784 10.765 202.109 11.6448 198.564 12.8351C193.6 14.4913 189.538 17.0272 184.252 17.8552C172.583 19.7183 160.527 20.7534 148.729 22.2025C136.673 23.7033 124.424 25.7217 112.24 25.9287C100.571 26.1357 89.8688 23.8069 78.5223 22.1507C67.756 20.5981 57.8277 20.8569 47.1903 22.8753C41.5815 23.9621 35.9727 25.3077 30.235 25.7735C24.2393 26.291 18.2437 25.4112 12.3126 25.1524C9.60487 25.0489 6.96164 25.1007 4.31841 25.2559C4.25394 29.1892 4.125 33.3295 4.125 37.3145C4.125 33.5882 4.25394 29.7067 4.31841 26.0322Z",
    fill: "url(#paint14_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M4.90234 9.05697C16.2489 3.82989 29.1427 5.7965 41.7786 5.48598C51.9003 5.22721 61.7641 2.12202 71.7568 0.879944C76.2051 0.879944 80.7179 0.82818 85.3597 0.82818C86.3267 0.98344 87.2938 1.13869 88.2608 1.3457C104.636 5.02018 118.626 8.17715 135.839 4.39917C140.481 3.3641 145.123 2.32902 149.7 1.3457C159.499 1.50096 169.041 1.70798 177.937 1.91499C178.646 1.65623 179.356 1.44923 180.065 1.24222C170.588 0.983449 160.337 0.776422 149.7 0.621162C145.058 1.65623 140.481 2.69131 135.839 3.67462C118.561 7.50436 104.636 4.29564 88.2608 0.621162C87.2938 0.414149 86.3267 0.207144 85.3597 0.103638C80.7179 0.103638 76.2051 0.103649 71.7568 0.155402C61.7641 1.39748 51.9003 4.50267 41.7786 4.76144C29.1427 5.07196 16.2489 3.10531 4.90234 8.33239C4.90234 8.69466 4.90234 9.05694 4.90234 9.47096C4.90234 9.47096 4.90234 9.2122 4.90234 9.10869V9.05697Z",
    fill: "url(#paint15_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M205.334 26.7568C194.697 29.4997 183.543 28.7234 172.584 29.1892C164.074 29.5514 156.466 31.311 148.666 33.7952C140.994 36.1758 133.773 40.0056 125.263 39.9538C117.527 39.9021 110.242 37.3662 102.506 36.8486C98.8311 36.5899 75.8801 39.488 74.0105 36.4864C74.0105 36.3828 73.946 36.2794 73.8816 36.2276C73.7526 36.5381 73.7526 36.9004 74.0105 37.2627C75.8801 40.2643 98.8311 37.3662 102.506 37.6249C110.242 38.1425 117.527 40.6784 125.263 40.7301C133.773 40.7819 140.994 36.9521 148.666 34.5715C156.466 32.1391 164.074 30.3277 172.584 29.9654C183.543 29.4997 194.697 30.276 205.334 27.5331C214.36 25.2042 223.514 23.2375 232.927 22.099C233.636 21.9954 234.345 21.9437 235.054 21.8402C235.054 22.4095 235.054 22.927 235.054 23.4963C235.054 22.6682 235.054 21.892 235.054 21.0639C234.345 21.1674 233.571 21.2709 232.927 21.3226C223.514 22.4612 214.36 24.4279 205.334 26.7568Z",
    fill: "url(#paint16_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M174.711 4.08847C186.122 6.52088 197.597 3.6227 209.266 3.93322C217.841 4.19199 226.415 4.86479 234.925 5.8481C234.925 7.19369 234.925 9.57432 234.989 12.576C234.989 9.21204 234.925 6.57265 234.925 5.12356C226.415 4.14025 217.841 3.46744 209.266 3.20868C197.984 2.89816 186.896 5.53756 175.807 3.51918C175.42 3.67444 175.033 3.88146 174.711 4.08847Z",
    fill: "url(#paint17_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M175.938 3.57113C177.227 3.00184 178.646 2.48431 180.128 2.07028C179.355 2.07028 178.517 2.07031 177.678 2.01855C176.582 2.43258 175.551 2.84658 174.648 3.36411C175.035 3.46762 175.487 3.51939 175.873 3.62289L175.938 3.57113Z",
    fill: "url(#paint18_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M210.171 29.2409C217.585 26.705 226.546 24.8419 235.056 24.3243V23.4963C225.321 24.0656 214.941 26.4462 207.012 29.6032C207.721 29.2926 208.881 29.2409 210.235 29.2927L210.171 29.2409Z",
    fill: "url(#paint19_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M73.882 36.2276C74.7201 34.3645 80.9736 33.2776 81.6827 31.6215C81.4893 31.5697 81.2959 31.518 81.1025 31.4145C79.104 32.9154 73.0439 34.0539 73.9465 36.2276H73.882Z",
    fill: "url(#paint20_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M183.802 23.5999C172.52 24.8937 161.173 25.9806 149.891 27.1191C138.222 28.3095 126.553 29.9656 114.82 30.2761C103.924 30.5866 93.2871 28.2059 82.6497 26.4463C71.6255 24.6349 61.1815 24.0657 50.1573 26.0323C43.8393 27.1709 36.6832 29.9656 30.1719 28.827C30.3008 29.1893 30.4942 29.4998 30.6876 29.7586C37.07 30.6901 43.9682 28.0507 50.1573 26.9121C61.1815 24.8937 71.6255 25.5148 82.6497 27.3261C93.2871 29.0858 103.924 31.4664 114.82 31.1559C126.553 30.8454 138.286 29.1375 149.891 27.9989C161.173 26.8604 172.52 25.8253 183.802 24.4797C193.472 23.3411 201.595 18.6316 211.072 16.7167C218.937 15.1124 226.931 14.0773 234.99 13.4563C234.99 13.1458 234.99 12.887 234.99 12.6282C226.931 13.2492 218.937 14.2843 211.072 15.8887C201.531 17.8036 193.472 22.5649 183.802 23.6517V23.5999Z",
    fill: "url(#paint21_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M48.7393 44.6114C50.7378 44.8184 53.4455 43.7316 55.3796 43.3176C60.0858 42.3343 64.7921 41.558 69.6272 40.9887C77.7503 40.0571 85.8734 39.9536 93.9965 40.2641C104.956 40.6782 115.013 43.6281 125.586 45.6465C129.39 46.371 140.027 49.3727 143.638 47.3543C145.185 46.5263 145.185 46.1123 144.669 45.8017C144.476 46.0088 144.153 46.2158 143.638 46.5263C140.027 48.4929 129.39 45.543 125.586 44.8184C115.013 42.8 104.956 39.9019 93.9965 39.4361C85.809 39.1256 77.7503 39.2291 69.6272 40.1606C64.7921 40.7299 60.0858 41.5062 55.3796 42.4895C53.4455 42.9036 50.7378 43.9904 48.7393 43.7834C47.4499 43.6281 46.6118 43.4211 46.2895 43.1106C45.7092 44.0421 46.6118 44.3526 48.7393 44.6114Z",
    fill: "url(#paint22_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M153.76 49.9937C153.76 49.9937 153.438 50.2524 153.309 50.356C154.92 52.2708 156.983 53.6164 159.24 54.8067C160.98 55.376 162.721 55.9453 164.462 56.5663C160.658 54.5997 156.597 53.0471 153.76 49.9937Z",
    fill: "url(#paint23_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M200.434 47.6132C199.532 48.0272 198.693 48.3895 198.242 48.6482C203.4 48.1307 213.973 47.3544 217.454 43.9905C217.261 43.887 217.067 43.7317 216.874 43.6282C213.457 46.2158 205.656 47.0957 200.434 47.6132Z",
    fill: "url(#paint24_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M205.783 44.0423C205.783 44.0423 206.234 43.68 206.363 43.5248C199.916 39.1775 173.032 42.4897 168.777 48.5448C168.971 48.6483 169.164 48.7001 169.293 48.7518C174.773 43.266 198.691 40.3161 205.783 43.9906V44.0423Z",
    fill: "url(#paint25_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M47.7743 7.03866C55.3816 6.36587 62.6666 4.24401 70.145 3.10544C75.1736 2.32914 80.2667 1.96687 85.2308 3.10544C89.0989 3.98525 92.6447 5.69308 96.3194 6.88341C111.728 11.9035 125.846 8.95356 141.254 6.62466C150.409 5.22732 165.817 2.07035 174.198 7.24568C174.585 7.19392 174.907 7.14218 175.294 7.09042C167.171 0.931787 150.796 4.3475 141.254 5.79659C125.846 8.12549 111.728 11.1272 96.3194 6.05537C92.5802 4.8133 89.0989 3.15717 85.2308 2.27737C80.2667 1.1388 75.1736 1.50107 70.145 2.27737C62.6666 3.41594 55.3816 5.53784 47.7743 6.21063C33.5266 7.50446 18.054 3.88175 4.90234 9.41934C4.90234 9.67811 4.90234 9.98862 4.90234 10.2991C18.1185 4.70979 33.5911 8.33249 47.8387 7.03866H47.7743Z",
    fill: "url(#paint26_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M233.957 51.9605C227.51 52.8403 221.063 53.6166 214.616 54.4964C205.075 55.7902 195.92 57.2393 186.508 58.1191C186.508 59.0507 185.799 60.034 184.509 60.3445C183.994 60.448 183.542 60.5515 183.026 60.655C176.257 60.7585 169.037 60.8103 161.494 60.862C153.306 59.9305 144.99 58.5332 136.738 58.8954C129.066 59.206 121.716 59.2577 114.109 58.2227C106.824 57.2393 99.668 55.6867 92.2541 55.1174C76.4591 53.9271 60.9221 58.4297 45.1272 57.0841C37.262 56.4113 29.848 53.8236 21.9183 53.1508C15.6004 52.6333 10.056 54.0306 4.7051 56.1525C4.7051 56.049 4.7051 55.9972 4.7051 55.8937H4.64062C4.64062 56.3078 4.7051 56.67 4.76957 56.9806C10.1205 54.8587 15.6648 53.4096 21.9828 53.9789C29.848 54.6516 37.262 57.2393 45.1917 57.9121C60.9866 59.3094 76.4592 54.7552 92.3185 55.9455C99.7325 56.5148 106.889 58.0674 114.174 59.0507C121.781 60.0858 129.13 60.034 136.802 59.7235C145.119 59.4129 153.371 60.8103 161.558 61.6901C169.037 61.6384 176.322 61.5349 183.091 61.4831C183.607 61.3796 184.058 61.2761 184.574 61.1726C185.863 60.8621 186.572 59.8788 186.572 58.9472C196.049 58.1191 205.204 56.6183 214.681 55.3244C221.321 54.4446 227.897 53.6166 234.473 52.7368C234.279 52.478 234.15 52.2192 234.022 51.9605H233.957Z",
    fill: "url(#paint27_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M235.051 39.3324C234.535 39.1771 234.084 39.1254 233.89 39.0736C227.701 38.5043 221.125 40.1087 215.065 38.8666C210.359 37.935 207.071 36.2789 201.978 35.8649C189.149 34.8816 176.126 34.9334 163.361 36.5377C160.267 36.9 142.022 38.8666 142.473 43.0586C142.473 43.1622 142.473 43.2656 142.538 43.3174C143.698 39.5394 160.395 37.7798 163.361 37.3658C176.126 35.7614 189.149 35.7097 201.978 36.693C207.007 37.0552 210.359 38.7114 215.065 39.6947C221.125 40.9368 227.701 39.3324 233.89 39.9017C234.084 39.9017 234.535 40.0052 235.051 40.1604C235.051 37.8315 235.051 35.3991 235.051 32.9667C235.051 35.0886 235.051 37.2623 235.051 39.3324Z",
    fill: "url(#paint28_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M32.6867 48.5445C35.6523 49.3208 37.8442 51.0286 40.6164 52.0637C45.3227 53.8233 50.867 53.1505 55.8956 52.84C63.6319 52.426 71.3037 51.7532 78.9755 51.4426C91.6115 50.9769 104.054 53.047 116.497 54.5996C118.302 54.5996 120.042 54.4961 121.847 54.3408C107.6 52.84 93.4166 50.0453 78.9755 50.5628C71.2392 50.8734 63.5674 51.4944 55.8956 51.9602C50.867 52.2189 45.3871 52.9435 40.6164 51.1839C37.8442 50.1488 35.6523 48.441 32.6867 47.6647C28.4962 46.5261 24.1123 46.5778 19.7284 46.7848C14.5064 47.0436 9.34893 47.6647 4.19141 48.3892C4.19141 48.234 4.19141 48.0787 4.19141 47.9752C4.19141 48.3892 4.19141 48.855 4.19141 49.269C9.34893 48.5445 14.5064 47.9234 19.7284 47.6647C24.0479 47.4577 28.4962 47.4059 32.6867 48.5445Z",
    fill: "url(#paint29_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M18.9529 36.9516C21.5316 37.5726 23.2078 39.4357 25.98 39.9532C33.7808 41.4541 54.0885 31.9315 60.9867 36.848C61.3091 36.848 61.5669 36.7445 61.8248 36.6928C55.8937 30.2236 34.1031 40.6778 25.98 39.0734C23.2078 38.5559 21.5316 36.6928 18.9529 36.0717C15.9873 35.3989 11.9902 36.3305 9.08912 36.6928C7.41292 36.8998 5.8012 37.1068 4.125 37.3138C4.125 37.5726 4.125 37.8831 4.125 38.1419C5.8012 37.9349 7.41292 37.6761 9.08912 37.5209C11.9902 37.1586 15.9873 36.227 18.9529 36.8998V36.9516Z",
    fill: "url(#paint30_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M42.0973 12.2139C42.2262 11.5411 42.5486 10.8166 43.1288 9.98851C42.9998 9.93675 42.8064 9.88501 42.6775 9.83325C42.1617 10.7131 41.9683 11.4894 42.0973 12.2139Z",
    fill: "url(#paint31_linear_5770_110529)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.23,
    d: "M35.3279 14.1802C39.196 14.1802 37.3909 13.9732 39.1316 15.681C41.0656 17.6477 42.4195 18.2687 45.5785 18.838C55.6357 20.5976 66.7243 18.3722 76.846 17.8547C88.7083 17.2854 99.4101 19.5625 111.143 20.3388C133.45 21.8396 155.434 14.853 177.224 12.1618C187.539 10.868 198.241 10.1434 209.008 10.0399C209.975 9.83289 210.942 9.67764 211.909 9.52238C212.618 9.41887 213.327 9.31538 214.036 9.21187C201.658 9.10837 189.216 9.88465 177.224 11.3337C155.434 14.0249 133.45 21.0116 111.143 19.5108C99.4746 18.7345 88.7083 16.4573 76.846 17.0266C66.7243 17.4924 55.6357 19.7695 45.5785 18.0099C42.4195 17.4406 41.0656 16.8196 39.1316 14.853C37.3909 13.1451 39.1316 13.3004 35.3279 13.3521C33.0715 13.3521 30.8151 13.2486 28.5587 13.3521C20.5 13.4556 12.5058 14.3354 4.64062 15.6293C4.64062 15.9398 4.64062 16.1985 4.64062 16.4573C12.5058 15.1117 20.5 14.2837 28.6231 14.1802C30.8795 14.1802 33.1359 14.2319 35.3924 14.1802H35.3279Z",
    fill: "url(#paint32_linear_5770_110529)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_5770_110529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5284 38.1706C35.5284 39.3855 35.3191 40.2891 34.9005 40.8812C34.482 41.4733 33.8439 41.7694 32.9863 41.7694C32.1287 41.7694 31.4907 41.4733 31.0721 40.8812C30.6535 40.2891 30.4442 39.3855 30.4442 38.1706V22.765C30.4442 21.4071 30.7046 20.473 31.2252 19.9625C31.7459 19.4521 32.6545 19.1968 33.9511 19.1968H38.5299C41.0516 19.1968 43.0424 19.8809 44.5023 21.2489C45.9622 22.6067 46.6922 24.4495 46.6922 26.7772C46.6922 29.1457 46.0082 30.9987 44.6401 32.3361C43.2721 33.6735 41.3732 34.3422 38.9434 34.3422H35.5284V38.1706ZM35.5284 29.7327H37.7183C38.8719 29.7327 39.7397 29.4877 40.3216 28.9977C40.9036 28.4974 41.1945 27.7573 41.1945 26.7772C41.1945 25.7869 40.9087 25.0569 40.337 24.5873C39.7754 24.1075 38.9026 23.8676 37.7183 23.8676H35.5284V29.7327ZM49.464 31.9226V22.5199C49.464 21.305 49.6733 20.4015 50.0918 19.8094C50.5104 19.2071 51.1485 18.9059 52.0061 18.9059C52.8636 18.9059 53.5017 19.2071 53.9203 19.8094C54.3389 20.4015 54.5482 21.305 54.5482 22.5199V31.356C54.5482 33.3264 54.9208 34.8118 55.6661 35.8123C56.4216 36.8026 57.5446 37.2978 59.0351 37.2978C60.5154 37.2978 61.6334 36.8026 62.3888 35.8123C63.1443 34.8118 63.5221 33.3264 63.5221 31.356V22.5199C63.5221 21.305 63.7313 20.4015 64.1499 19.8094C64.5685 19.2071 65.2015 18.9059 66.0488 18.9059C66.9064 18.9059 67.5445 19.2071 67.9631 19.8094C68.3816 20.4015 68.5909 21.305 68.5909 22.5199V31.9226C68.5909 35.1589 67.7487 37.6755 66.0641 39.4723C64.3796 41.2589 62.0366 42.1522 59.0351 42.1522C56.0234 42.1522 53.6753 41.2589 51.9908 39.4723C50.3062 37.6755 49.464 35.1589 49.464 31.9226ZM77.6414 32.6883V38.1706C77.6414 39.3855 77.4321 40.2891 77.0135 40.8812C76.5949 41.4733 75.9569 41.7694 75.0993 41.7694C74.2417 41.7694 73.6036 41.4733 73.1851 40.8812C72.7665 40.2891 72.5572 39.3855 72.5572 38.1706V22.765C72.5572 21.4071 72.8175 20.473 73.3382 19.9625C73.8589 19.4521 74.7675 19.1968 76.0641 19.1968H80.015C82.6592 19.1968 84.7368 19.8247 86.2477 21.0804C87.7587 22.326 88.5142 24.0207 88.5142 26.1646C88.5142 27.7573 88.0395 29.0896 87.09 30.1615C86.1508 31.2233 84.8491 31.8971 83.185 32.1829L87.1972 36.6393C87.7077 37.2008 88.0854 37.7265 88.3304 38.2166C88.5857 38.6964 88.7133 39.1405 88.7133 39.5489C88.7133 40.2227 88.4836 40.7893 88.0241 41.2487C87.5647 41.7081 86.9879 41.9378 86.2937 41.9378C85.8445 41.9378 85.4106 41.8 84.992 41.5244C84.5836 41.2487 84.1089 40.7791 83.5678 40.1155L77.6414 32.6883ZM77.6414 29.2886H79.9844C81.0155 29.2886 81.8118 29.0487 82.3733 28.5689C82.9349 28.0891 83.2156 27.4101 83.2156 26.5322C83.2156 25.6848 82.94 25.0314 82.3887 24.572C81.8374 24.1024 81.0564 23.8676 80.0457 23.8676H77.6414V29.2886ZM101.117 42.1522C97.8403 42.1522 95.2012 41.0752 93.2002 38.921C91.1992 36.7567 90.1987 33.9032 90.1987 30.3606C90.1987 26.8997 91.2349 24.0717 93.3074 21.8768C95.3799 19.6716 98.0036 18.569 101.179 18.569C103.047 18.569 104.624 18.9263 105.911 19.6409C107.207 20.3556 107.856 21.1876 107.856 22.1371C107.856 22.7496 107.641 23.2856 107.212 23.745C106.784 24.2045 106.278 24.4342 105.696 24.4342C105.37 24.4342 104.706 24.2912 103.705 24.0054C102.715 23.7093 101.883 23.5613 101.209 23.5613C99.5452 23.5613 98.2129 24.1891 97.2124 25.4449C96.2221 26.6904 95.727 28.3698 95.727 30.4831C95.727 32.5556 96.2323 34.1993 97.2431 35.4142C98.264 36.6188 99.6371 37.2212 101.362 37.2212C102.159 37.2212 103.067 37.0323 104.088 36.6546C105.109 36.2666 105.783 36.0727 106.11 36.0727C106.63 36.0727 107.1 36.2973 107.519 36.7465C107.937 37.1957 108.146 37.7112 108.146 38.2932C108.146 39.3447 107.468 40.2533 106.11 41.019C104.762 41.7745 103.098 42.1522 101.117 42.1522ZM115.283 32.4892V38.1706C115.283 39.3855 115.073 40.2891 114.655 40.8812C114.236 41.4733 113.598 41.7694 112.741 41.7694C111.883 41.7694 111.245 41.4733 110.826 40.8812C110.408 40.2891 110.199 39.3855 110.199 38.1706V22.5199C110.199 21.305 110.408 20.4015 110.826 19.8094C111.245 19.2071 111.883 18.9059 112.741 18.9059C113.598 18.9059 114.236 19.2071 114.655 19.8094C115.073 20.4015 115.283 21.305 115.283 22.5199V27.7879H124.624V22.5199C124.624 21.305 124.833 20.4015 125.252 19.8094C125.671 19.2071 126.309 18.9059 127.166 18.9059C128.024 18.9059 128.662 19.2071 129.08 19.8094C129.499 20.4015 129.708 21.305 129.708 22.5199V38.1706C129.708 39.3855 129.499 40.2891 129.08 40.8812C128.662 41.4733 128.024 41.7694 127.166 41.7694C126.309 41.7694 125.671 41.4733 125.252 40.8812C124.833 40.2891 124.624 39.3855 124.624 38.1706V32.4892H115.283ZM137.304 37.2978L136.538 39.5489C136.293 40.2942 135.961 40.8659 135.543 41.264C135.135 41.652 134.655 41.846 134.103 41.846C133.399 41.846 132.817 41.6163 132.358 41.1568C131.908 40.6872 131.684 40.1002 131.684 39.3958C131.684 39.1099 131.704 38.8445 131.745 38.5994C131.786 38.3544 131.847 38.1298 131.929 37.9256L137.733 22.1677C138.151 21.0345 138.672 20.2024 139.295 19.6716C139.928 19.1407 140.704 18.8753 141.622 18.8753C142.49 18.8753 143.241 19.1305 143.874 19.6409C144.517 20.1412 145.012 20.8712 145.359 21.8308L151.01 37.8491C151.122 38.186 151.204 38.4871 151.255 38.7526C151.316 39.018 151.347 39.2528 151.347 39.457C151.347 40.1614 151.112 40.7383 150.642 41.1875C150.173 41.6265 149.57 41.846 148.835 41.846C148.182 41.846 147.636 41.6418 147.197 41.2334C146.768 40.825 146.426 40.2023 146.171 39.3651L145.543 37.2978H137.304ZM138.743 32.6117H144.073L141.5 24.3423L138.743 32.6117ZM167.932 34.5872C167.932 36.823 167.135 38.6352 165.543 40.0236C163.96 41.4019 161.872 42.091 159.279 42.091C157.288 42.091 155.589 41.7337 154.18 41.019C152.771 40.3044 152.066 39.4672 152.066 38.5076C152.066 37.8235 152.291 37.2722 152.74 36.8537C153.2 36.4351 153.812 36.2258 154.578 36.2258C154.956 36.2258 155.747 36.4147 156.952 36.7924C158.156 37.1701 159.172 37.359 159.999 37.359C160.714 37.359 161.311 37.1395 161.791 36.7005C162.271 36.2615 162.511 35.7153 162.511 35.0619C162.511 34.3575 162.265 33.7909 161.775 33.3621C161.285 32.9333 160.234 32.4739 158.621 31.9839C156.283 31.2896 154.649 30.4678 153.72 29.5183C152.791 28.5587 152.327 27.2723 152.327 25.6593C152.327 23.5868 153.072 21.8921 154.563 20.5751C156.063 19.2581 158.013 18.5996 160.413 18.5996C162.179 18.5996 163.634 18.9161 164.777 19.5491C165.92 20.1718 166.492 20.9528 166.492 21.8921C166.492 22.5659 166.288 23.0968 165.88 23.4847C165.481 23.8624 164.925 24.0513 164.21 24.0513C163.812 24.0513 163.164 23.9237 162.265 23.6685C161.367 23.403 160.688 23.2703 160.229 23.2703C159.473 23.2703 158.871 23.449 158.422 23.8063C157.973 24.1534 157.748 24.6128 157.748 25.1845C157.748 26.0932 158.738 26.8588 160.719 27.4816C161.178 27.6245 161.536 27.7368 161.791 27.8185C163.924 28.5332 165.481 29.4367 166.461 30.5291C167.442 31.6112 167.932 32.964 167.932 34.5872ZM179.754 19.1968C180.959 19.1968 181.862 19.3959 182.464 19.7941C183.067 20.182 183.368 20.7793 183.368 21.5858C183.368 22.3719 183.067 22.9589 182.464 23.3469C181.872 23.7348 180.969 23.9288 179.754 23.9288H175.619V27.9104H179.187C180.402 27.9104 181.306 28.1044 181.898 28.4923C182.5 28.8803 182.801 29.4724 182.801 30.2687C182.801 31.065 182.5 31.6572 181.898 32.0451C181.306 32.4229 180.402 32.6117 179.187 32.6117H175.619V36.7924H179.907C181.132 36.7924 182.041 36.9864 182.633 37.3743C183.225 37.7623 183.521 38.3493 183.521 39.1354C183.521 39.9317 183.225 40.5239 182.633 40.9118C182.041 41.2998 181.132 41.4937 179.907 41.4937H173.981C172.664 41.4937 171.76 41.2691 171.27 40.8199C170.78 40.3707 170.535 39.5285 170.535 38.2932V22.765C170.535 21.4071 170.795 20.473 171.316 19.9625C171.837 19.4521 172.745 19.1968 174.042 19.1968H179.754ZM191.454 36.7924H193.766C195.798 36.7924 197.314 36.236 198.314 35.1232C199.325 34.0104 199.83 32.331 199.83 30.085C199.83 28.0227 199.315 26.4811 198.284 25.4602C197.263 24.4393 195.726 23.9288 193.674 23.9288H191.454V36.7924ZM193.965 19.1968C195.384 19.1968 196.635 19.3245 197.717 19.5797C198.809 19.8349 199.774 20.228 200.611 20.7588C202.081 21.6981 203.235 22.9998 204.072 24.6639C204.92 26.3178 205.343 28.135 205.343 30.1156C205.343 33.6173 204.368 36.3891 202.418 38.431C200.479 40.4728 197.824 41.4937 194.455 41.4937H189.815C188.498 41.4937 187.595 41.2691 187.104 40.8199C186.614 40.3707 186.369 39.5285 186.369 38.2932V22.765C186.369 21.4071 186.63 20.473 187.15 19.9625C187.671 19.4521 188.58 19.1968 189.876 19.1968H193.965Z",
    fill: "#531300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_5770_110529",
    x: 30.4453,
    y: 18.569,
    width: 174.898,
    height: 24.1583,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.57502
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.768627 0 0 0 0 0.32549 0 0 0 0 0.0313726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5770_110529"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5770_110529",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.15004
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_5770_110529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5770_110529",
    x1: 118.879,
    y1: -6.31356,
    x2: 120.043,
    y2: 82.2447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5770_110529",
    x1: 119.587,
    y1: 3.2087,
    x2: 119.587,
    y2: 55.8935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5770_110529",
    x1: 119.587,
    y1: 3.20808,
    x2: 119.587,
    y2: 55.8929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5770_110529",
    x1: 108.696,
    y1: 7.76298,
    x2: 108.696,
    y2: 17.2856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5770_110529",
    x1: 55.8931,
    y1: 28.9818,
    x2: 55.8931,
    y2: 32.1388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5770_110529",
    x1: 143.703,
    y1: 43.4209,
    x2: 143.703,
    y2: 45.5946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5770_110529",
    x1: 53.9614,
    y1: 37.1586,
    x2: 53.9614,
    y2: 42.5927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5770_110529",
    x1: 202.304,
    y1: 44.1457,
    x2: 202.304,
    y2: 47.5097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5770_110529",
    x1: 63.243,
    y1: 52.0122,
    x2: 63.243,
    y2: 56.1007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5770_110529",
    x1: 84.3245,
    y1: 45.2842,
    x2: 84.3245,
    y2: 56.2559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5770_110529",
    x1: 185.414,
    y1: 40.2127,
    x2: 185.414,
    y2: 49.1142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5770_110529",
    x1: 221.066,
    y1: 29.3958,
    x2: 221.066,
    y2: 32.6045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_5770_110529",
    x1: 23.9149,
    y1: 8.48733,
    x2: 23.9149,
    y2: 14.9565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_5770_110529",
    x1: 201.85,
    y1: 46.0086,
    x2: 201.85,
    y2: 52.3743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_5770_110529",
    x1: 109.081,
    y1: 11.3861,
    x2: 109.081,
    y2: 35.1408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_5770_110529",
    x1: 92.5158,
    y1: 0.569416,
    x2: 92.5158,
    y2: 8.64291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_5770_110529",
    x1: 154.403,
    y1: 22.0472,
    x2: 154.403,
    y2: 39.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_5770_110529",
    x1: 204.818,
    y1: 3.67446,
    x2: 204.818,
    y2: 11.7997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_5770_110529",
    x1: 176.26,
    y1: 29.3958,
    x2: 175.096,
    y2: 73.1958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_5770_110529",
    x1: 220.873,
    y1: 30.5865,
    x2: 219.667,
    y2: 74.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_5770_110529",
    x1: 78.008,
    y1: 26.705,
    x2: 76.8443,
    y2: 70.4535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_5770_110529",
    x1: 132.291,
    y1: 28.2059,
    x2: 131.086,
    y2: 71.9558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_5770_110529",
    x1: 96.3174,
    y1: 27.2223,
    x2: 95.1121,
    y2: 70.9721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_5770_110529",
    x1: 159.949,
    y1: 28.9302,
    x2: 158.744,
    y2: 72.6798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_5770_110529",
    x1: 208.557,
    y1: 30.2758,
    x2: 207.352,
    y2: 74.0257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_5770_110529",
    x1: 188.247,
    y1: 29.7066,
    x2: 187.083,
    y2: 73.4552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_5770_110529",
    x1: 89.2923,
    y1: 27.0155,
    x2: 88.087,
    y2: 70.7653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_5770_110529",
    x1: 120.62,
    y1: 27.8434,
    x2: 119.457,
    y2: 71.6438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_5770_110529",
    x1: 189.278,
    y1: 29.758,
    x2: 188.072,
    y2: 73.5078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_5770_110529",
    x1: 64.0832,
    y1: 26.3423,
    x2: 62.8778,
    y2: 70.0921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_5770_110529",
    x1: 33.4584,
    y1: 25.5141,
    x2: 32.2947,
    y2: 69.2626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_5770_110529",
    x1: 41.9683,
    y1: 25.7215,
    x2: 40.8046,
    y2: 69.4699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_5770_110529",
    x1: 108.694,
    y1: 27.5325,
    x2: 107.488,
    y2: 71.2822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68C16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#852C00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchased);
export default __webpack_public_path__ + "static/media/purchased.4a7b84e1bfe855d5c8181e95abba31b7.svg";
export { ForwardRef as ReactComponent };